import {
  Button,
  Divider,
  Grid,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import React from "react";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSSCheckBoxField from "../../Components/CheckBox/WSCheckBox";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import WSSelectField from "../../Components/Select/WSSelect";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import WSDateField from "../../Components/DateField/WSDateField";

export const ItemSettings: React.FC<any> = React.memo((props) => {
  const { control, register, handleSubmit, setValue, reset, watch } = useForm();

  const navigate = useNavigate();
  const handleCancelClick = () => {
    navigate("/");
  };

  const mrp1 = watch("mrp", false);
  const serialNo1 = watch("serialNo", false);
  const batchNo1 = watch("batchNo", false);
  const expDate1 = watch("expDate", false);
  const mfgDate1 = watch("mfgDate", false);
  const modelNo1 = watch("modelNo", false);
  const size1 = watch("size", false);

  return (
    <Grid p={2}>
      <Paper sx={{ padding: 3, position: "relative" }} elevation={0}>
        {/* Close Icon in top right */}
        <IconButton
          size="small"
          sx={{ position: "absolute", top: 8, right: 8 }}
          onClick={handleCancelClick} // replace with your close logic
        >
          <WSIcons.CloseIcon fontSize="small" />
        </IconButton>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography fontWeight={"bold"}>Item Settings</Typography>
                <Divider />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Enable Item"
                  id="enableItem"
                  control={control}
                  {...register("enableItem")}
                  rules={{ required: false }}
                  name="enableItem"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSelectField
                  rules={{ required: true }}
                  control={control}
                  id="Whatdoyousell"
                  {...register("Whatdoyousell")}
                  name="Whatdoyousell"
                  label="What do you sell?"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Barcode Scan"
                  id="barcodeScan"
                  control={control}
                  {...register("barcodeScan")}
                  rules={{ required: false }}
                  name="barcodeScan"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Stock Maintenance"
                  id="barcodeScan"
                  control={control}
                  {...register("stockMaintenance")}
                  rules={{ required: false }}
                  name="stockMaintenance"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Manufacturing"
                  id="manufacturing"
                  control={control}
                  {...register("manufacturing")}
                  rules={{ required: false }}
                  name="manufacturing"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Show Low Stock Dialog"
                  id="showLowStockDialog"
                  control={control}
                  {...register("showLowStockDialog")}
                  rules={{ required: false }}
                  name="showLowStockDialog"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Default Unit"
                  id="defaultUnit"
                  control={control}
                  {...register("defaultUnit")}
                  rules={{ required: false }}
                  name="defaultUnit"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Items Unit"
                  id="itemsUnit"
                  control={control}
                  {...register("itemsUnit")}
                  rules={{ required: false }}
                  name="itemsUnit"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Item Category"
                  id="itemCategory"
                  control={control}
                  {...register("itemCategory")}
                  rules={{ required: false }}
                  name="itemCategory"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Party Wise Item Rate"
                  id="partyWiseItemRate"
                  control={control}
                  {...register("partyWiseItemRate")}
                  rules={{ required: false }}
                  name="partyWiseItemRate"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Description"
                  id="description"
                  control={control}
                  {...register("description")}
                  rules={{ required: false }}
                  name="description"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Item wise Tax"
                  id="itemwiseTax"
                  control={control}
                  {...register("itemwiseTax")}
                  rules={{ required: false }}
                  name="itemwiseTax"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Item wise Discount"
                  id="itemwiseDiscount"
                  control={control}
                  {...register("itemwiseDiscount")}
                  rules={{ required: false }}
                  name="itemwiseDiscount"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Update Sale Price from Transaction"
                  id="updateSalePricefromTransaction"
                  control={control}
                  {...register("updateSalePricefromTransaction")}
                  rules={{ required: false }}
                  name="updateSalePricefromTransaction"
                />
              </Grid>
              <Grid item xs={12}>
                <WSTextField
                  label={"Quantity"}
                  {...register("quantity")}
                  id="quantity"
                  name="quantity"
                  control={control}
                  type={TextType.Number}
                  rules={{ required: true }}
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Wholesale Price"
                  id="wholesalePrice"
                  control={control}
                  {...register("wholesalePrice")}
                  rules={{ required: false }}
                  name="wholesalePrice"
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography fontWeight={"bold"}>
                  Additional Item Fields
                </Typography>
                <Divider />
              </Grid>
              <Grid item xs={12}>
                <Typography fontWeight={"bold"}>MRP/Price</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <WSSCheckBoxField
                  label="MRP"
                  id="mrp"
                  control={control}
                  {...register("mrp")}
                  rules={{ required: false }}
                  name="mrp"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <WSTextField
                  label={"MRP"}
                  {...register("mrp1")}
                  id="mrp1"
                  name="mrp1"
                  control={control}
                  rules={{ required: true }}
                  disabled={!mrp1}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography fontWeight={"bold"}>Serial No. Tracking</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <WSSCheckBoxField
                  label="Serial No./ IMEI No. etc"
                  id="serialNo"
                  control={control}
                  {...register("serialNo")}
                  rules={{ required: false }}
                  name="serialNo"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <WSTextField
                  label={"Serial No."}
                  {...register("serialNo1")}
                  id="serialNo1"
                  name="serialNo1"
                  control={control}
                  rules={{ required: true }}
                  disabled={!serialNo1}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography fontWeight={"bold"}>Batch Tracking</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <WSSCheckBoxField
                  label="Batch No."
                  id="batchNo"
                  control={control}
                  {...register("batchNo")}
                  rules={{ required: false }}
                  name="batchNo"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <WSTextField
                  label={"Batch No."}
                  {...register("batchNo1")}
                  id="batchNo1"
                  name="batchNo1"
                  control={control}
                  rules={{ required: true }}
                  disabled={!batchNo1}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <WSSCheckBoxField
                  label="Exp Date"
                  id="expDate"
                  control={control}
                  {...register("expDate")}
                  rules={{ required: false }}
                  name="expDate"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <WSDateField
                  id="expDate1"
                  name="expDate1"
                  label={" Exp Date "}
                  dateFormat="DD-MM-YYYY"
                  denyFuturOrPast="custom"
                  control={control}
                  rules={{ required: false }}
                  disabled={!expDate1}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <WSSCheckBoxField
                  label="Mfg Date"
                  id="mfgDate"
                  control={control}
                  {...register("mfgDate")}
                  rules={{ required: false }}
                  name="mfgDate"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <WSDateField
                  id="mfgDate1"
                  name="mfgDate1"
                  label={"Mfg Date"}
                  dateFormat="DD-MM-YYYY"
                  denyFuturOrPast="custom"
                  control={control}
                  rules={{ required: false }}
                  disabled={!mfgDate1}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <WSSCheckBoxField
                  label="Model No"
                  id="modelNo"
                  control={control}
                  {...register("modelNo")}
                  rules={{ required: false }}
                  name="modelNo"
                />
              </Grid>
 <Grid item xs={12} sm={6}>
                 <WSTextField
                  label={"Model No"}
                  {...register("modelNo1")}
                  id="modelNo1"
                  name="modelNo1"
                  control={control}
                  rules={{ required: true }}
                  disabled={!modelNo1}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <WSSCheckBoxField
                  label="Size"
                  id="size"
                  control={control}
                  {...register("size")}
                  rules={{ required: false }}
                  name="size"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                 <WSTextField
                  label={"Size"}
                  {...register("size1")}
                  id="size1"
                  name="size1"
                  control={control}
                  rules={{ required: true }}
                  disabled={!size1}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography fontWeight={"bold"}>Item Custom Fields</Typography>
                <Divider />
              </Grid>
              <Grid item xs={12}>
                <Button>
                  Add Custom Fields <WSIcons.ArrowRight />
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
});
